import {
  getReferralEvent as publicGetReferralEvent,
  queryReferralEvent as publicQueryReferralEvent,
  typedQueryReferralEvent as publicTypedQueryReferralEvent,
  getReferralStatistics as publicGetReferralStatistics,
  queryReferringCustomerTotals as publicQueryReferringCustomerTotals,
  queryReferredFriendActions as publicQueryReferredFriendActions,
} from './loyalty-referral-v1-referral-event-tracker.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ReferralEventQuery,
  ReferralEventsQueryBuilder,
  typedQueryReferralEvent as universalTypedQueryReferralEvent,
} from './loyalty-referral-v1-referral-event-tracker.universal.js';
import { onReferralEventCreated as publicOnReferralEventCreated } from './loyalty-referral-v1-referral-event-tracker.public.js';

function customQueryReferralEvent(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryReferralEvent(httpClient)(),
    typedQueryFunction: (query: ReferralEventQuery) =>
      publicTypedQueryReferralEvent(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ReferralEventsQueryBuilder;
  function overloadedQuery(
    query: ReferralEventQuery
  ): ReturnType<typeof universalTypedQueryReferralEvent>;
  function overloadedQuery(query?: ReferralEventQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getReferralEvent: MaybeContext<
  BuildRESTFunction<typeof publicGetReferralEvent> &
    typeof publicGetReferralEvent
> = /*#__PURE__*/ createRESTModule(publicGetReferralEvent);
export const getReferralStatistics: MaybeContext<
  BuildRESTFunction<typeof publicGetReferralStatistics> &
    typeof publicGetReferralStatistics
> = /*#__PURE__*/ createRESTModule(publicGetReferralStatistics);
export const queryReferringCustomerTotals: MaybeContext<
  BuildRESTFunction<typeof publicQueryReferringCustomerTotals> &
    typeof publicQueryReferringCustomerTotals
> = /*#__PURE__*/ createRESTModule(publicQueryReferringCustomerTotals);
export const queryReferredFriendActions: MaybeContext<
  BuildRESTFunction<typeof publicQueryReferredFriendActions> &
    typeof publicQueryReferredFriendActions
> = /*#__PURE__*/ createRESTModule(publicQueryReferredFriendActions);
export const queryReferralEvent: MaybeContext<
  BuildRESTFunction<typeof customQueryReferralEvent> &
    typeof customQueryReferralEvent
> = /*#__PURE__*/ createRESTModule(customQueryReferralEvent);
/** */
export const onReferralEventCreated: BuildEventDefinition<
  typeof publicOnReferralEventCreated
> &
  typeof publicOnReferralEventCreated = createEventModule(
  publicOnReferralEventCreated
);

export {
  Reward,
  SortOrder,
  Status,
  DiscountType,
  WebhookIdentityType,
} from './loyalty-referral-v1-referral-event-tracker.universal.js';
export {
  ReferralEvent,
  ReferralEventEventTypeOneOf,
  ReferredFriendSignupEvent,
  V1SuccessfulReferralEvent,
  V1ActionEvent,
  V1Trigger,
  RewardEvent,
  RewardEventReceiverOneOf,
  CreateReferralEventRequest,
  CreateReferralEventResponse,
  GetReferralEventRequest,
  GetReferralEventResponse,
  QueryReferralEventRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryReferralEventResponse,
  CursorPagingMetadata,
  Cursors,
  GetReferralStatisticsRequest,
  GetReferralStatisticsResponse,
  QueryReferringCustomerTotalsRequest,
  QueryReferringCustomerTotalsResponse,
  ReferringCustomerTotal,
  QueryReferredFriendActionsRequest,
  QueryReferredFriendActionsResponse,
  ReferredFriendAction,
  ReferredFriendActionRewardTypeOptionsOneOf,
  V1Coupon,
  Coupon,
  CouponDiscountTypeOptionsOneOf,
  CouponScopeOrMinSubtotalOneOf,
  FixedAmountDiscount,
  PercentageDiscount,
  CouponScope,
  Group,
  LoyaltyPoints,
  ReprocessReferralEventsRequest,
  ReprocessReferralEventsRequestEntityOneOf,
  ReprocessReferralEventsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  SuccessfulReferralEvent,
  ReferredFriendDetails,
  ReferredFriendActionEvent,
  Trigger,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ReferralEventCreatedEnvelope,
  ReferralEventsQueryResult,
  ReferralEventsQueryBuilder,
  ReferralEventQuerySpec,
  QueryReferringCustomerTotalsOptions,
  QueryReferredFriendActionsOptions,
} from './loyalty-referral-v1-referral-event-tracker.universal.js';
export { utils } from './loyalty-referral-v1-referral-event-tracker.universal.js';
export {
  RewardWithLiterals,
  SortOrderWithLiterals,
  StatusWithLiterals,
  DiscountTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  ReferralEventQuery,
} from './loyalty-referral-v1-referral-event-tracker.universal.js';
